<template>
  <div class="sidebar-wrapper has-background-dark">
    <div class="sidebar-spacer" />
    <aside
      class="intl-sidebar"
      @click="hideSidebarOnMobile"
    >
      <slot />
    </aside>
  </div>
</template>

<script>
export default {
  mounted () {
    this.hideSidebarOnMobile()
  },
  methods: {
    hideSidebarOnMobile () {
      if (this.getWindowWidth() < 400) {
        this.$emit('toggleSidebar')
      }
    },
    getWindowWidth () {
      return Math.max(document.documentElement.clientWidth, window.innerWidth || 0)
    }
  }
}
</script>
<style lang="scss" scoped>
@import '../../sass/_variables.scss';

.sidebar-wrapper {
  width: $sidebar-width;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  padding-bottom: $navbar-height - .4rem;
  transition: left $animation-fast;
  z-index: 200;

  .sidebar-spacer {
    width: 100%;
    margin-top: $navbar-height;
  }

  .intl-sidebar {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    background: var(--sidebar-color);
  }
}

.mini .sidebar-wrapper {
  left: $sidebar-width * -1 + $sidebar-icon-width;
}

.sidebar-closed .sidebar-wrapper{
  left: $sidebar-width * -1;
}

.sidebar-size-toggle {
  position: absolute;
  bottom: 0px;
  right: 0px;
  width: $sidebar-icon-width;
  height: $sidebar-icon-width;
  text-align: center;
  line-height: $sidebar-icon-width;
  transition: transform $animation-fast;
  cursor: pointer;
}

.mini .sidebar-size-toggle {
  transform: rotate(180deg);
}

p.menu-label {
  margin: 1em;
  text-align: center;
}

@media only screen and (max-width: $break-small) {

  .mini .sidebar-wrapper {
    left: 0;
  }

  .sidebar-closed .sidebar-wrapper{
    left: $sidebar-width * -1;
  }
}

</style>
